import Link from 'next/link'

import { Text } from '@wartek-id/text-v1'
import { Button } from '@wartek-id/button-v1'
import { Badge, type BadgeProps } from '@wartek-id/badge'

import Navbar from 'app/KinerjaPage/components/Navbar'
import { useAPIKinerjaProfile } from 'api/kinerja/useAPIKinerja'
import { isKsDefinitifPlt } from 'app/KinerjaKSPage/utils/profile'
import { PENGELOLAAN_KINERJA_GURU_PATH } from 'app/KinerjaShared/constants/path'

import type { KinerjaStatus } from 'types/kinerja'

type KinerjaStatusMap<T> = {
  [key in KinerjaStatus]?: T
}

const KinerjaStatusTranslate: KinerjaStatusMap<string> = {
  NOT_FOUND: 'Belum Diajukan',
  WAITING_APPROVAL: 'Butuh Penyesuaian',
  DRAFT: 'Belum Diajukan',
  REVISED: 'Telah Ditetapkan',
  APPROVED: 'Telah Dievaluasi',
}

const KinerjaStatusBadgeVariant: KinerjaStatusMap<BadgeProps['variant']> = {
  NOT_FOUND: 'warning',
  WAITING_APPROVAL: 'critical',
  DRAFT: 'warning',
  REVISED: 'success',
  APPROVED: 'informational',
}

const KinerjaStatusAction: KinerjaStatusMap<string> = {
  NOT_FOUND: 'Lakukan Perencanaan',
  WAITING_APPROVAL: 'Lakukan Perencanaan',
  DRAFT: 'Lakukan Perencanaan',
  REVISED: 'Laporkan Hasil Kerja',
  APPROVED: 'Lihat Nilai Kinerja',
}

const KinerjaStatusHref: KinerjaStatusMap<string> = {
  NOT_FOUND: `${PENGELOLAAN_KINERJA_GURU_PATH}/perencanaan`,
  WAITING_APPROVAL: '',
  DRAFT: `${PENGELOLAAN_KINERJA_GURU_PATH}/perencanaan`,
  REVISED: `${PENGELOLAAN_KINERJA_GURU_PATH}/pelaksanaan`,
  APPROVED: `${PENGELOLAAN_KINERJA_GURU_PATH}/evaluasi`,
}

interface KinerjaHistoryAppProps {
  isKinerjaKsEnabled?: boolean
  isKinerjaPsEnabled?: boolean
}

const dummyDataKinerja = [
  {
    tahun: 2024,
    status: 'DRAFT',
    pangkatGolongan: 'III/A',
    jenjang: 'Ahli Pratama',
  },
  {
    tahun: 2023,
    status: 'REVISED',
    pangkatGolongan: 'III/A',
    jenjang: 'Ahli Pratama',
  },
  {
    tahun: 2022,
    status: 'APPROVED',
    pangkatGolongan: 'III/A',
    jenjang: 'Ahli Pratama',
  },
]

const KinerjaHistoryApp = ({
  isKinerjaKsEnabled = false,
  isKinerjaPsEnabled = false,
}: KinerjaHistoryAppProps) => {
  const { data: { data: profile } = {} } = useAPIKinerjaProfile()

  return (
    <div className="pt-16">
      <div className="flex" style={{ minHeight: 'calc(100vh - 64px)' }}>
        <Navbar
          activeMenu="history"
          showKinerjaAnda={isKinerjaKsEnabled && isKsDefinitifPlt(profile)}
          showKinerjaPs={isKinerjaPsEnabled}
        />
        <div className="p-9 flex-1">
          <Text variant="heading-md">Riwayat</Text>

          <div className="mt-3">
            <div className="bg-white rounded-md shadow-md">
              <table className="w-full text-left text-sm">
                <thead>
                  <tr className="bg-gray-5">
                    <th className="px-6 py-4 font-semibold">Tahun</th>
                    <th className="px-6 py-4 font-semibold">Status</th>
                    <th className="px-6 py-4 font-semibold">Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {dummyDataKinerja.map((kinerja, i) => (
                    <tr
                      key={`kinerja-${i}`}
                      className="border-y border-gray-20"
                    >
                      <td className="px-6 py-4">{kinerja.tahun}</td>
                      <td className="px-6 py-4">
                        <Badge
                          variant={KinerjaStatusBadgeVariant[kinerja.status]}
                        >
                          {KinerjaStatusTranslate[kinerja.status]}
                        </Badge>
                      </td>
                      <td className="px-6 py-4">
                        <Link href={KinerjaStatusHref[kinerja.status]} passHref>
                          <Button color="white" size="sm">
                            {KinerjaStatusAction[kinerja.status]}
                          </Button>
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default KinerjaHistoryApp
